'use client';

import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { type ListingType } from '@/features/listing/types/listing-types';
import ListingTypeSvg from '@/ui/svg/listing-type-svg';

import styles from './listing-icon-box.module.scss';

interface ListingIconBoxProps {
  listingType: ListingType,
  onClick?: () => void,
  href?: string,
}

export default function ListingIconBox(props: ListingIconBoxProps) {
  const {
    href,
    listingType,
    onClick,
  } = props;

  const router = useRouter();

  const translationsListingType = useTranslations('listing.service-type-landing');

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      router.push(href);
    }
  };

  return (
    <button
      className={styles.listingIconBox}
      onClick={handleClick}
    >
      <div className={styles.listingIconBox_imageWrapper}>
        <ListingTypeSvg type={listingType} />
      </div>

      <p className={styles.listingIconBox_name}>
        {translationsListingType(listingType)}
      </p>
    </button>
  );
}
